// @ts-nocheck

import { useEffect, useRef, useState } from 'react';

import { Target } from '../client';
import { getAppDOMElement } from '../DOMElements';

const Directions = {
  UP: 1,
  DOWN: -1,
};

const useScrollUpAvailable = (yThreshold = Target.__MOBILE__ ? 100 : 300) => {
  const [isScrollUpAvailable, setIsScrollUpAvailable] = useState(false);
  const yThresholdRef = useRef();
  const pidRef = useRef(null);
  const previousScrollTop = useRef(0);

  useEffect(() => {
    yThresholdRef.current = yThreshold;
  }, [yThreshold]);

  useEffect(() => {
    const targetScrollTop = Target.__MOBILE__ ? getAppDOMElement() : document.documentElement;
    const targetListener = Target.__MOBILE__ ? targetScrollTop : window;

    const scrollEventName = 'scroll';

    const scrollCallback = () => {
      const scrollTop = targetScrollTop?.scrollTop ?? 0;
      const direction = Math.sign(previousScrollTop.current - scrollTop);
      const topLimit = yThresholdRef.current ?? 0;

      if (pidRef.current) {
        clearTimeout(pidRef.current);
      }

      if (scrollTop >= topLimit && direction === Directions.UP) {
        setIsScrollUpAvailable(true);

        pidRef.current = setTimeout(() => {
          setIsScrollUpAvailable(false);
          pidRef.current = null;
        }, 2000);
      } else {
        setIsScrollUpAvailable(false);
      }

      previousScrollTop.current = scrollTop;
    };

    targetListener.addEventListener(scrollEventName, scrollCallback);

    return () => {
      targetListener.removeEventListener(scrollEventName, scrollCallback);
    };
  }, []);

  return isScrollUpAvailable;
};

export default useScrollUpAvailable;
